import {
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Typography,
  withStyles,
} from '@material-ui/core'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import CollectionCrud from '../../common/Components/CollectionCrud'
import DateInput from '../../common/Components/DateInput'
import {NumberInput, TextInput} from '@oniti/oniti-inputs'
import {collectionActions} from '../../../reducers/collectionsReducer'
import {axiosClient} from '../../../axios'
import {axiosErrorHandler} from '../../../reducers/notificationReducer'
import NavettesCss from './css/NavettesCss'
import {ImportExport, LocalShipping} from '@material-ui/icons'

// Rampe séquentielle bleue (skill dataviz) : clair = vide, foncé = plein.
const OCCUPANCY_RAMP = ['#cde2fb', '#9ec5f4', '#5598e7', '#256abf', '#184f95', '#0d366b']

class Navettes extends Component {
  state = {
    jours: null, // {navette_uuid: {'YYYY-MM-DD': places_restantes}}
  }

  componentDidMount() {
    let {dispatch} = this.props

    collectionActions(dispatch, 'navettes', 'INDEX')
    collectionActions(dispatch, 'sejours', 'INDEX', {})
    this.loadJours()
  }

  // Récupère les places restantes jour par jour auprès du token-server
  loadJours() {
    axiosClient.get('navettes/jours')
      .then(response => this.setState({jours: response.data}))
      .catch(error => axiosErrorHandler(this.props.dispatch, error))
  }

  getDate(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleDateString('fr-FR', options)
  }

  onExportHandler(line) {
    let url = process.env.REACT_APP_API_URL + '/exports/navettes/' + line.uuid

    window.open(url, '_blank')
  }

  getActionsButtons(line) {
    var btns = []

    btns.push(
      <IconButton
        aria-label="Export"
        key="export"
        color="primary"
        title="Export des passagers"
        onClick={this.onExportHandler.bind(this, line)}
      >
        <ImportExport/>
      </IconButton>
    )
    return btns
  }

  /**
   * ####################################################################################
   * ############################## PRÉLÈVEMENTS MANUELS ################################
   * ####################################################################################
   */

  getNavettesList() {
    return (this.props.navettesStore.list || [])
  }

  getSejoursList() {
    return (this.props.sejoursStore.list || [])
  }

  getPrelevementModalTitle(prelevement) {
    return <><LocalShipping/> <span>Prélever des places dans une navette</span></>
  }

  getDeleteModalTitle() {
    return <><LocalShipping/> <span>Redonner les places</span></>
  }

  getDeleteModalContent() {
    return (
      <Typography>
        Êtes-vous sûr de vouloir supprimer ce prélèvement ? Les places seront rendues disponibles.
      </Typography>
    )
  }

  // Rafraîchit le graphe après création/suppression d'un prélèvement
  prelevementActionsCallback(action) {
    if (action === 'create' || action === 'delete') {
      this.loadJours()
    }
  }

  getPrelevementModalContent(prelevement, store, onChangeHandler) {
    const {classes} = this.props
    const navettes = this.getNavettesList()
    const sejours = this.getSejoursList()

    // arrêts disponibles pour la navette sélectionnée (informatif)
    const navette = navettes.find(n => n.uuid === prelevement.navette_uuid)
    const arrets = (navette && navette.arrets_array) ? navette.arrets_array : {}

    // La sélection d'une navette sélectionne automatiquement son premier arrêt.
    const onNavetteChange = (name, event) => {
      const uuid = event.target.value
      const selected = navettes.find(n => n.uuid === uuid)
      const arretsKeys = (selected && selected.arrets_array) ? Object.keys(selected.arrets_array) : []
      const firstArret = arretsKeys.length > 0 ? arretsKeys[0] : ''
      onChangeHandler('navette_uuid', {target: {value: uuid}}, () => {
        onChangeHandler('arret', {target: {value: firstArret}})
      })
    }

    // La sélection d'un séjour pré-remplit les dates de début / fin.
    // On chaîne les appels via le callback : chaque setState de la modale part de
    // this.state.detail, donc des appels synchrones successifs s'écraseraient
    // mutuellement (seul le dernier champ serait conservé).
    const onSejourChange = (name, event) => {
      const uuid = event.target.value
      const sejour = sejours.find(s => s.uuid === uuid)
      onChangeHandler('_sejour_uuid', {target: {value: uuid}}, () => {
        if (!sejour) {
          return
        }
        onChangeHandler('date_debut', {target: {value: sejour.date_debut}}, () => {
          onChangeHandler('date_fin', {target: {value: sejour.date_fin}})
        })
      })
    }

    return (
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12} sm={6}>
          <TextInput
            id="navette_uuid"
            label="Navette (circuit)"
            value={prelevement.navette_uuid || ''}
            margin="normal"
            name="navette_uuid"
            fullWidth
            collectionStore={store}
            onChangeHandler={onNavetteChange}
            select
          >
            {navettes.map(n => (
              <MenuItem value={n.uuid} key={n.uuid}>{n.circuit}</MenuItem>
            ))}
          </TextInput>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextInput
            id="arret"
            label="Arrêt (facultatif)"
            value={prelevement.arret || ''}
            margin="normal"
            name="arret"
            fullWidth
            collectionStore={store}
            onChangeHandler={onChangeHandler}
            select
            disabled={!prelevement.navette_uuid}
            helperText="Informatif : n'influe pas sur le décompte des places"
          >
            <MenuItem value="">(aucun)</MenuItem>
            {Object.keys(arrets).map(key => (
              <MenuItem value={key} key={key}>{arrets[key]}</MenuItem>
            ))}
          </TextInput>
        </Grid>

        <Grid item xs={12}>
          <TextInput
            id="_sejour_uuid"
            label="Pré-remplir les dates depuis un séjour (facultatif)"
            value={prelevement._sejour_uuid || ''}
            margin="normal"
            name="_sejour_uuid"
            fullWidth
            collectionStore={store}
            onChangeHandler={onSejourChange}
            select
          >
            <MenuItem value="">(saisie manuelle)</MenuItem>
            {sejours.map(s => (
              <MenuItem value={s.uuid} key={s.uuid}>
                {s.libelle} ({this.getDate(s.date_debut)} → {this.getDate(s.date_fin)})
              </MenuItem>
            ))}
          </TextInput>
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput
            id="date_debut"
            label="Date de début"
            value={prelevement.date_debut || null}
            margin="normal"
            name="date_debut"
            fullWidth
            collectionStore={store}
            onChangeHandler={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput
            id="date_fin"
            label="Date de fin"
            value={prelevement.date_fin || null}
            margin="normal"
            name="date_fin"
            fullWidth
            collectionStore={store}
            onChangeHandler={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <NumberInput
            id="places"
            label="Nombre de places à prélever"
            value={prelevement.places}
            margin="normal"
            name="places"
            fullWidth
            collectionStore={store}
            onChangeHandler={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12}>
          <TextInput
            id="note"
            label="Note (ex : nom de l'enfant)"
            value={prelevement.note || ''}
            margin="normal"
            name="note"
            fullWidth
            multiline
            collectionStore={store}
            onChangeHandler={onChangeHandler}
          />
        </Grid>
      </Grid>
    )
  }

  /**
   * ####################################################################################
   * ############################### GRAPHE JOUR PAR JOUR ###############################
   * ####################################################################################
   */

  // Renvoie l'index de la rampe (0 = vide … 5 = plein) et l'encre du texte
  getOccupancyStyle(remaining, capacity) {
    if (!capacity || capacity <= 0) {
      return {fill: '#e1e0d9', ink: '#52514e'}
    }
    let idx
    if (remaining <= 0) {
      idx = 5
    } else {
      const occ = 1 - remaining / capacity // 0 vide … 1 plein
      if (occ <= 0.001) idx = 0
      else if (occ <= 0.25) idx = 1
      else if (occ <= 0.5) idx = 2
      else if (occ <= 0.75) idx = 3
      else idx = 4
    }
    return {fill: OCCUPANCY_RAMP[idx], ink: idx >= 2 ? '#ffffff' : '#0b0b0b'}
  }

  shortDay(jour) {
    // 'YYYY-MM-DD' -> 'DD/MM'
    const parts = jour.split('-')
    return parts.length === 3 ? parts[2] + '/' + parts[1] : jour
  }

  getGraph() {
    const {classes} = this.props
    const {jours} = this.state
    const navettes = this.getNavettesList()

    if (!jours || navettes.length === 0) {
      return <Typography variant="body2">Chargement du graphe…</Typography>
    }

    // union triée de tous les jours
    const daySet = {}
    Object.keys(jours).forEach(navUuid => {
      Object.keys(jours[navUuid] || {}).forEach(d => {
        daySet[d] = true
      })
    })
    const days = Object.keys(daySet).sort()

    if (days.length === 0) {
      return <Typography variant="body2">Aucun jour de séjour à afficher.</Typography>
    }

    const LABEL_W = 150
    const CELL_W = 30
    const CELL_H = 28
    const MONTH_H = 24
    const DAY_H = 20
    const HEADER_H = MONTH_H + DAY_H
    const svgW = LABEL_W + days.length * CELL_W + 4
    const svgH = HEADER_H + navettes.length * CELL_H + 4

    // regroupe les jours consécutifs par mois (pour le bandeau du haut)
    const MONTHS_FR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
    const monthRuns = []
    days.forEach((d, i) => {
      const [year, month] = d.split('-')
      const key = year + '-' + month
      const last = monthRuns[monthRuns.length - 1]
      if (last && last.key === key) {
        last.count += 1
      } else {
        monthRuns.push({key, start: i, count: 1, label: MONTHS_FR[parseInt(month, 10) - 1] + ' ' + year})
      }
    })

    return (
      <div className={classes.graphScroll}>
        <svg width={svgW} height={svgH} role="img">
          {/* en-tête : bandeau des mois + séparateurs verticaux */}
          {monthRuns.map((run) => {
            const xStart = LABEL_W + run.start * CELL_W
            const xCenter = xStart + (run.count * CELL_W) / 2
            return (
              <g key={run.key}>
                <text
                  x={xCenter}
                  y={MONTH_H - 8}
                  fontSize="13"
                  fontWeight="600"
                  fill="#0b0b0b"
                  textAnchor="middle"
                >
                  {run.label}
                </text>
                {run.start > 0 && (
                  <line
                    x1={xStart}
                    y1={MONTH_H - 2}
                    x2={xStart}
                    y2={svgH - 2}
                    stroke="#e1e0d9"
                    strokeWidth="1"
                  />
                )}
              </g>
            )
          })}

          {/* en-tête : numéro du jour (à l'endroit, lisible) */}
          {days.map((d, i) => {
            const x = LABEL_W + i * CELL_W + CELL_W / 2
            return (
              <text
                key={'h' + d}
                x={x}
                y={HEADER_H - 6}
                fontSize="12"
                fill="#52514e"
                textAnchor="middle"
              >
                {d.split('-')[2]}
              </text>
            )
          })}

          {/* lignes : navettes */}
          {navettes.map((navette, r) => {
            const y = HEADER_H + r * CELL_H
            const parJour = jours[navette.uuid] || {}
            return (
              <g key={navette.uuid}>
                <text
                  x={LABEL_W - 8}
                  y={y + CELL_H / 2 + 4}
                  fontSize="11"
                  fill="#0b0b0b"
                  textAnchor="end"
                >
                  {navette.circuit.length > 22 ? navette.circuit.slice(0, 21) + '…' : navette.circuit}
                </text>
                {days.map((d, i) => {
                  const remaining = parJour[d]
                  const x = LABEL_W + i * CELL_W
                  if (remaining === undefined) {
                    return (
                      <rect
                        key={d}
                        x={x + 1}
                        y={y + 1}
                        width={CELL_W - 2}
                        height={CELL_H - 2}
                        rx="3"
                        fill="#f9f9f7"
                      />
                    )
                  }
                  const style = this.getOccupancyStyle(remaining, navette.places)
                  return (
                    <g key={d}>
                      <rect
                        x={x + 1}
                        y={y + 1}
                        width={CELL_W - 2}
                        height={CELL_H - 2}
                        rx="3"
                        fill={style.fill}
                      >
                        <title>
                          {navette.circuit} — {this.shortDay(d)} : {remaining} / {navette.places} place(s) restante(s)
                        </title>
                      </rect>
                      <text
                        x={x + CELL_W / 2}
                        y={y + CELL_H / 2 + 4}
                        fontSize="10"
                        fill={style.ink}
                        textAnchor="middle"
                        style={{pointerEvents: 'none'}}
                      >
                        {remaining}
                      </text>
                    </g>
                  )
                })}
              </g>
            )
          })}
        </svg>
      </div>
    )
  }

  getGraphLegend() {
    const {classes} = this.props
    const labels = ['Vide', '', '', '', '', 'Plein']
    return (
      <div className={classes.legend}>
        <span className={classes.legendLabel}>Taux d'occupation :</span>
        {OCCUPANCY_RAMP.map((color, i) => (
          <span key={color} className={classes.legendItem}>
            <span className={classes.legendSwatch} style={{backgroundColor: color}}/>
            {labels[i] ? <span className={classes.legendLabel}>{labels[i]}</span> : null}
          </span>
        ))}
      </div>
    )
  }

  render() {
    const {classes} = this.props

    return (
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="button" gutterBottom className={classes.sectionTitle}>
            Navettes
          </Typography>

          <CollectionCrud
            collectionName={'navettes'}
            loadDatas={false}
            showBtnEdit={false}
            showBtnAdd={false}
            showBtnDelete={false}
            datatableConfig={{
              showPagination: true,
              showSearch: true,
              rowsPerPageOptions: [20, 50, 100],
            }}
            cellsConfig={[
              {
                datakey: 'circuit',
                title: 'Circuit',
                sortable: true,
                searchable: true,
              },
              {
                datakey: 'arrets_string',
                title: 'Arrêts',
                sortable: false,
                searchable: true,
              },
              {
                datakey: 'places',
                title: 'Places',
                sortable: false,
                searchable: false,
              },
              {
                format: this.getActionsButtons.bind(this),
                sortable: false,
              },
            ]}
          />
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.divider}/>
          <Typography variant="button" gutterBottom className={classes.sectionTitle}>
            Places restantes, jour par jour
          </Typography>
          <Typography variant="body2" gutterBottom>
            Couleur = taux d'occupation ; le nombre affiché est le nombre de places encore disponibles.
          </Typography>
          {this.getGraphLegend()}
          {this.getGraph()}
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.divider}/>
          <Typography variant="button" gutterBottom className={classes.sectionTitle}>
            Prélèvements manuels
          </Typography>
          <Typography variant="body2" gutterBottom>
            Réservez des places pour des inscriptions faites en dehors de l'application. Supprimer un
            prélèvement rend les places à nouveau disponibles.
          </Typography>

          <CollectionCrud
            collectionName={'navette_prelevements'}
            loadDatas={true}
            showBtnEdit={false}
            showBtnAdd={true}
            showBtnDelete={true}
            defaultValues={{places: 1}}
            createUpdateModalTitle={this.getPrelevementModalTitle.bind(this)}
            createUpdateModalContent={this.getPrelevementModalContent.bind(this)}
            deleteModalTitle={this.getDeleteModalTitle.bind(this)}
            deleteModalContent={this.getDeleteModalContent.bind(this)}
            actionsCallback={this.prelevementActionsCallback.bind(this)}
            datatableConfig={{
              showPagination: true,
              showSearch: true,
              rowsPerPageOptions: [20, 50, 100],
              defaultSort: 'date_debut',
              sortType: 'desc',
            }}
            cellsConfig={[
              {
                datakey: 'circuit',
                title: 'Circuit',
                sortable: true,
                searchable: true,
              },
              {
                datakey: 'arret_nom',
                title: 'Arrêt',
                sortable: false,
                searchable: true,
              },
              {
                datakey: 'date_debut',
                title: 'Période',
                sortable: true,
                searchable: false,
                format: (obj) => this.getDate(obj.date_debut) + ' → ' + this.getDate(obj.date_fin),
              },
              {
                datakey: 'places',
                title: 'Places',
                sortable: true,
                searchable: false,
              },
              {
                datakey: 'note',
                title: 'Note',
                sortable: false,
                searchable: true,
              },
            ]}
          />
        </Grid>
      </Grid>
    )
  }

}

Navettes = withStyles(NavettesCss)(Navettes)

Navettes = connect((store) => {
  return {
    navettesStore: store.collections.navettes,
    sejoursStore: store.collections.sejours,
    navettePrelevementsStore: store.collections.navette_prelevements,
  }
})(Navettes)

export default Navettes
